// How screens open the app's dialogs. The dialogs themselves live in src/dialogs/ and are mounted by
// <DialogsProvider>; screens only ever call these functions.

import { createContext, use } from 'react';

export interface RequestDialogOptions {
  /** Pre-fills the From/To dates. */
  date?: string;
  /** Pre-selects who the leave is for (HR can book for anyone). */
  userId?: string;
}

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

export interface Dialogs {
  openRequest(options?: RequestDialogOptions): void;
  openDetail(requestId: string): void;
  /** Asks "are you sure?" and resolves to the answer. */
  confirm(options: ConfirmOptions): Promise<boolean>;
}

export const DialogsContext = createContext<Dialogs | null>(null);

export function useDialogs(): Dialogs {
  const dialogs = use(DialogsContext);
  if (!dialogs) throw new Error('useDialogs must be used inside <DialogsProvider>.');
  return dialogs;
}
